<template>
  <div class="options-filter__wrap">
    <button class="btn w-104px ml-5" @click="isModalOpen = true">
      <v-icon class="mr-2" :class="{ 'primary--text': isFiltering }"
        >filter_list</v-icon
      >
      <span>
        <span v-if="isFiltering" :class="{ 'primary--text': isFiltering }"
          >已篩選
        </span>
        <span v-else>未篩選</span>
      </span>
    </button>
    <div class="options-filter__dialog-wrap" v-if="isModalOpen">
      <div class="options-filter__dialog">
        <!-- 篩選器標題與關閉按鈕 -->
        <div class="mb-5 d-flex justify-space-between">
          <h3>篩選器</h3>
          <button @click="isModalOpen = false">
            <v-icon color="black">close</v-icon>
          </button>
        </div>
        <!-- 面試期間 -->
        <div class="mb-5">
          <h5 class="mb-1">面試期間</h5>
          <DateFilter
            modalWidth="305px"
            buttonPlaceholder="篩選面試日期區間"
            appendIcon="date_range"
            :dateOfRegisterFilter.sync="filter.interviewPeriod"
          ></DateFilter>
        </div>
        <!-- 用人單位 -->
        <div class="mb-5">
          <h5 class="mb-1">用人單位</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            :options="['人力資源部', '工程部']"
            :selectedValue.sync="filter.unit"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 應徵職務 -->
        <div class="mb-5">
          <h5 class="mb-1">應徵職務</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            :options="['人力招募管理師', '工程師']"
            :selectedValue.sync="filter.position"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 面試主管 -->
        <div class="mb-5">
          <h5 class="mb-1">面試主管</h5>
          <MultiSelectWithCheckbox
            placeholder="請選擇"
            :items="['李英豪', '羅嘉仁']"
            v-model="filter.supervisorsOfInterview"
          ></MultiSelectWithCheckbox>
        </div>
        <!-- 面試結果 -->
        <div class="mb-10px">
          <h5 class="mb-1">面試結果</h5>
          <v-radio-group row v-model="filter.result">
            <div
              v-for="item in ['不拘', '錄取', '未錄取', '黑名單']"
              :key="item"
              class="w-33 mb-10px"
            >
              <v-radio class="mr-01" :value="item">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text">
                    {{ item }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
        <!-- 履歷來源 -->
        <div class="mb-5">
          <h5 class="mb-1">履歷來源</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            :options="['104', '1111']"
            :selectedValue.sync="filter.resumeResource"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 面試階段 -->
        <div class="mb-5">
          <h5 class="mb-1">面試階段</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            modalTop="-290px"
            :options="['初試', '複試', '複試2', '複試3', '複試4', '複試5']"
            :selectedValue.sync="filter.phrase"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 職務類別 -->
        <div class="mb-5">
          <h5 class="mb-1">職務類別</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            modalTop="-290px"
            :options="['類別1', '類別2', '類別3', '類別4', '類別5', '類別6']"
            :selectedValue.sync="filter.category"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 權責主管 -->
        <div class="mb-10px">
          <h5 class="mb-1">權責主管</h5>
          <v-radio-group row v-model="filter.supervisorsOfResponsible">
            <div
              v-for="item in ['不拘', 'Y', 'N']"
              :key="item"
              class="w-33 mb-10px"
            >
              <v-radio class="mr-01" :value="item">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text">
                    {{ item }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
        <!-- 用人主管 -->
        <div class="mb-5">
          <h5 class="mb-1">用人主管</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            modalTop="-290px"
            :options="['王阿明', '陳小美', '方大同', '周啊倫', '蔡依明']"
            :selectedValue.sync="filter.supervisorsOfUse"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 招募窗口 -->
        <div class="mb-5">
          <h5 class="mb-1">招募窗口</h5>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇"
            buttonWidth="100%"
            modalWidth="100%"
            modalBodyHeight="208px"
            modalTop="-290px"
            :options="['王阿明', '陳小美', '方大同', '周啊倫', '蔡依明']"
            :selectedValue.sync="filter.contactPerson"
          ></SimpleSelectWithSearchInput>
        </div>
        <!-- 履歷表是否回收 -->
        <div class="mb-10px">
          <h5 class="mb-1">履歷表是否回收</h5>
          <v-radio-group row v-model="filter.isResumeRecycled">
            <div
              v-for="item in ['不拘', 'Y', 'N']"
              :key="item"
              class="w-33 mb-10px"
            >
              <v-radio class="mr-01" :value="item">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text">
                    {{ item }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
        <!-- actions -->
        <div class="d-flex mb-5">
          <button class="btn btn-primary w-50 mr-5" @click="applyHandler">
            套用
          </button>
          <button class="btn flex-grow-1 w-50" @click="clearHandler">
            全部清除
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import DateFilter from '@/components/F-1a__ADATA-members_Filter-StartEndDate.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    MultiSelectWithCheckbox,
    DateFilter,
  },
  data: () => ({
    filter: {
      interviewPeriod: [],
      unit: '',
      position: '',
      supervisorsOfInterview: [],
      result: '不拘',
      resumeResource: '',
      phrase: '',
      category: '',
      supervisorsOfResponsible: '不拘',
      supervisorsOfUse: '',
      contactPerson: '',
      isResumeRecycled: '不拘',
    },
    isModalOpen: false,
    isFiltering: false,
  }),
  methods: {
    applyHandler() {
      this.isFiltering = true;
      this.isModalOpen = false;
    },
    clearHandler() {
      this.filter.interviewPeriod.splice(0, this.filter.interviewPeriod.length);
      this.filter.supervisorsOfInterview.splice(
        0,
        this.filter.supervisorsOfInterview.length,
      );

      const template = {
        interviewPeriod: [],
        unit: '',
        position: '',
        supervisorsOfInterview: [],
        result: '不拘',
        resumeResource: '',
        phrase: '',
        category: '',
        supervisorsOfResponsible: '不拘',
        supervisorsOfUse: '',
        contactPerson: '',
        isResumeRecycled: '不拘',
      };
      this.$set(this, 'filter', template);
      this.isFiltering = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.options-filter {
  &__dialog-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 7, 25, 0.6);
    z-index: 10;
  }
  &__dialog {
    width: 360px;
    height: 100%;
    margin-left: auto;
    padding: 20px;
    background-color: $gray-100;
    overflow: auto;
  }
}
</style>
